export default __webpack_public_path__ + "659f13577fddfd9dce980deedd20a2ac.png";